import { Button, DatePicker } from "antd";
import dayjs, { Dayjs } from "dayjs";
import { useState } from "react";
import * as XLSX from "xlsx-js-style";
import { useAppSelector } from "../../../app/store";
import ExcelLogo from "../../../assets/images/xlsx.png";
import CustomModal from "../../../components/ui/CustomModal";
import { API_URL } from "../../../constants/apiUrl";
import {
  ATTENDANCE_MANAGEMENT_API,
  dbDateFormat,
} from "../../../constants/constants";
import { toast } from "../../../lib/toast";
import { ModalComponentProps } from "../../../types";
import { GetAttendanceExportType } from "../../../types/attendance";
import { defaultHeaders } from "../../../utils/params";

const { RangePicker } = DatePicker;

type Props = {
  loading: boolean;
  handleExcelLoading: (val: boolean) => void;
  downloadExcel: (val: any) => void;
  totalLength: number;
} & ModalComponentProps;

export default function DownloadCustomAttenModal({
  handleClose,
  handleExcelLoading,
  downloadExcel,
  totalLength,
  // loading,
  ...rest
}: Props) {
  // const { viewId } = useParams();
  const [loading, setLoading] = useState(false);
  // const { loading: excelLoading, downloadXlsx } = useDownloadEmployeeXlsx();
  const { access_token } = useAppSelector((state) => state.auth);
  // const today = dayjs();
  // const last30Days = today.subtract(30, "days");
  const [dates, setDates] = useState<[Dayjs, Dayjs]>([
    dayjs().subtract(1, "month"),
    dayjs(),
  ]);

  // const disabledDate = (current: dayjs.Dayjs) => {
  //   return current.isAfter(today, "day") || current.isBefore(last30Days, "day");
  // };

  // const handleDownloadExcel = () => {
  //   downloadXlsx(
  //     ATTENDANCE_MANAGEMENT_API + API_URL.getAttendanceExport,
  //     {
  //       start_date: dates?.[0]?.format(dbDateFormat),
  //       end_date: dates?.[1]?.format(dbDateFormat),
  //       skip: 0,
  //       limit: 10,
  //     },
  //     "Custom_attendance_report",
  //     "employees",
  //     (custom_attendance: GetAttendanceExportType["data"]["employees"][0]) => {
  //       return {
  //         "Employee ID": custom_attendance?.employee_id ?? "-",
  //         "Employee Name": custom_attendance?.employee_name ?? "-",
  //         "Employee Email": custom_attendance?.employee_email ?? "-",
  //         "Employee Department": custom_attendance?.employee_department ?? "-",
  //         "Employee Designation":
  //           custom_attendance?.employee_designation ?? "-",
  //         "Employee Line Manager": custom_attendance?.line_manager_name ?? "-",
  //         "Line Manager Email": custom_attendance?.line_manager_email ?? "-",
  //         "Employee Address": custom_attendance?.employee_address ?? "-",
  //         "Working Days": custom_attendance?.working_days ?? "-",
  //         Present: custom_attendance?.present ?? "-",
  //         "On time": custom_attendance?.on_time ?? "-",
  //         Late: custom_attendance?.late ?? "-",
  //         "Left Timely": custom_attendance?.left_timely ?? "-",
  //         "Left early": custom_attendance?.left_early ?? "-",
  //         "On leave": custom_attendance?.on_leave ?? "-",
  //         Absent: custom_attendance?.absent ?? "-",
  //         "Total Hours": custom_attendance?.total_hours ?? "-",
  //         Overtime: custom_attendance?.overtime ?? "-",
  //         "Total Remote Checkin":
  //           custom_attendance?.total_remote_checkin ?? "-",
  //         "Total Office Checkin":
  //           custom_attendance?.total_office_checkin ?? "-",
  //         "Total Remote Checkout":
  //           custom_attendance?.total_remote_checkout ?? "-",
  //         "Total Office Checkout":
  //           custom_attendance?.total_office_checkout ?? "-",
  //         "Total Checkout Missing":
  //           custom_attendance?.total_checkout_missing ?? "-",
  //         "Joining Prorated": custom_attendance?.joining_prorated ?? "-",
  //         "Leave Days": custom_attendance?.leave_days ?? "-",
  //         "Late Days": custom_attendance?.late_days ?? "-",
  //         "Absent Days": custom_attendance?.absent_days ?? "-",
  //       };
  //     }
  //   );
  // };

  // const api = `${EMPLOYEE_MANAGE_API}${API_URL.getEmployees}?status=active&skip=0&limit=0`;

  // const handleDownloadAll = async () => {
  //   handleExcelLoading(true);

  //   try {
  //     const res = await fetch(api, {
  //       headers: {
  //         Authorization: `Bearer ${access_token}`,
  //       },
  //     });
  //     const data = await res.json();
  //     const employees = data?.data?.employees || [];

  //     const attendanceResponses = await Promise.all(
  //       employees.map(async (item: any) => {
  //         const attendanceApi = `${ATTENDANCE_MANAGEMENT_API}${
  //           API_URL.getCustomAttendanceByEmployee
  //         }?business_member_id=${item?.id}&from_date=${dates?.[0]?.format(
  //           dbDateFormat
  //         )}&to_date=${dates?.[1]?.format(dbDateFormat)}`;

  //         const res = await fetch(attendanceApi, {
  //           headers: {
  //             Authorization: `Bearer ${access_token}`,
  //           },
  //         });
  //         const at = await res.json();

  //         // console.log(item);

  //         return (
  //           at?.data?.attendance_logs?.map((el: any) => ({
  //             ...el,
  //             name: item?.member?.profile?.name,
  //             email: item?.member?.profile?.email,
  //             employee_id: item?.employee_id,
  //             department: item?.role?.department?.name,
  //             designation: item?.role?.name,
  //           })) || []
  //         );
  //       })
  //     );

  //     const allAttendanceLogs = attendanceResponses.flat();

  //     const downloadedData = allAttendanceLogs?.map((attendance_details) => ({
  //       Name: attendance_details?.name ?? "-",
  //       Email: attendance_details?.email,
  //       "Employee ID": attendance_details?.employee_id ?? "-",
  //       Department: attendance_details?.department ?? "-",
  //       Designation: attendance_details?.designation ?? "-",
  //       Date: attendance_details?.date
  //         ? dayjs(attendance_details?.date, dbDateFormat).format(dateFormat)
  //         : "-",
  //       Status: attendance_details?.status ?? "-",
  //       "Check in time": attendance_details?.checkin_time ?? "-",
  //       "Check in status": attendance_details?.checkin_log?.status ?? "-",
  //       "Check in location": attendance_details?.checkin_log?.is_geo_location
  //         ? "Location"
  //         : attendance_details?.checkin_log?.is_in_wifi
  //         ? "Wifi"
  //         : attendance_details?.checkin_log?.is_remote
  //         ? "Remote"
  //         : "-",
  //       "Check in address":
  //         attendance_details?.checkin_log?.location?.address ?? "-",
  //       "Check out time": attendance_details?.checkout_time ?? "-",
  //       "Check out status": attendance_details?.checkout_log?.status ?? "-",
  //       "Check out location": attendance_details?.checkout_log?.is_geo_location
  //         ? "Location"
  //         : attendance_details?.checkout_log?.is_in_wifi
  //         ? "Wifi"
  //         : attendance_details?.checkout_log?.is_remote
  //         ? "Remote"
  //         : "-",
  //       "Check out address":
  //         attendance_details?.checkout_log?.location?.address ?? "-",
  //       "Total Hours":
  //         attendance_details?.checkin_time &&
  //         attendance_details?.checkout_time &&
  //         (attendance_details?.staying_time_in_minutes ||
  //           attendance_details?.staying_time_in_minutes === 0)
  //           ? convertMinutesToHoursWithText(
  //               attendance_details?.staying_time_in_minutes || 0
  //             )
  //           : "-",
  //       Overtime:
  //         attendance_details?.checkin_time &&
  //         attendance_details?.checkout_time &&
  //         (attendance_details?.overtime_in_minutes ||
  //           attendance_details?.overtime_in_minutes === 0)
  //           ? convertMinutesToHoursWithText(
  //               attendance_details?.overtime_in_minutes || 0
  //             )
  //           : "-",
  //       "Late check in note": attendance_details?.checkin_log?.note ?? "-",
  //       "Left early note": attendance_details?.checkout_log?.note ?? "-",
  //       "Attendance Reconciliation":
  //         attendance_details?.is_attendance_reconciled
  //           ? `Reconciliation by super admin (${attendance_details?.checkout_log?.updated_by_name})`
  //           : "-",
  //       "Shift Name": attendance_details?.shift_name
  //         ? underscoreToCapitalizeString(attendance_details?.shift_name)
  //         : "-",
  //     }));

  //     downloadExcel(downloadedData);
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   } finally {
  //     handleExcelLoading(false);
  //   }
  // };

  const handleDownloadExcel = async () => {
    setLoading(true);
    const limit = 10;
    let totalPage = Math.ceil(totalLength / limit);

    let downloadedData = [];

    for (let i = 0; i < totalPage; i++) {
      const skip = (i + 1 - 1) * limit;

      try {
        const apiUrl = ATTENDANCE_MANAGEMENT_API + API_URL.getAttendanceExport;
        const params = {
          start_date: dates?.[0]?.format(dbDateFormat),
          end_date: dates?.[1]?.format(dbDateFormat),
          skip,
          limit,
        };

        const queryString = new URLSearchParams(
          Object.fromEntries(
            Object.entries(params)
              .filter(([_, value]) => value !== undefined)
              .map(([key, value]) => [key, String(value)])
          )
        ).toString();

        const url = `${apiUrl}?${queryString}`;

        const headers = new Headers();
        headers.set("Content-Type", "application/json");
        const finalHeaders = defaultHeaders(headers, access_token);

        const response = await fetch(url, {
          method: "GET",
          headers: finalHeaders,
        });

        const result = await response.json();
        const data = result?.data?.employees || [];

        if (!data?.length) {
          toast("error", "Excel download failed.");
        }

        downloadedData.push(...data);

        // Update progress
        const progress = Math.round(((i + 1) / totalPage) * 100);
      } catch (err) {
        setLoading(false);
        toast("error", "Excel download failed.");
      }
    }

    const processedData = downloadedData.map(
      (custom_attendance: GetAttendanceExportType["data"]["employees"][0]) => {
        return {
          "Employee ID": custom_attendance?.employee_id ?? "-",
          "Employee Name": custom_attendance?.employee_name ?? "-",
          "Employee Email": custom_attendance?.employee_email ?? "-",
          "Employee Department": custom_attendance?.employee_department ?? "-",
          "Employee Designation":
            custom_attendance?.employee_designation ?? "-",
          "Employee Line Manager": custom_attendance?.line_manager_name ?? "-",
          "Line Manager Email": custom_attendance?.line_manager_email ?? "-",
          "Employee Address": custom_attendance?.employee_address ?? "-",
          "Working Days": custom_attendance?.working_days ?? "-",
          Present: custom_attendance?.present ?? "-",
          "On time": custom_attendance?.on_time ?? "-",
          Late: custom_attendance?.late ?? "-",
          "Left Timely": custom_attendance?.left_timely ?? "-",
          "Left early": custom_attendance?.left_early ?? "-",
          "On leave": custom_attendance?.on_leave ?? "-",
          Absent: custom_attendance?.absent ?? "-",
          "Total Hours": custom_attendance?.total_hours ?? "-",
          Overtime: custom_attendance?.overtime ?? "-",
          "Total Remote Checkin":
            custom_attendance?.total_remote_checkin ?? "-",
          "Total Office Checkin":
            custom_attendance?.total_office_checkin ?? "-",
          "Total Remote Checkout":
            custom_attendance?.total_remote_checkout ?? "-",
          "Total Office Checkout":
            custom_attendance?.total_office_checkout ?? "-",
          "Total Checkout Missing":
            custom_attendance?.total_checkout_missing ?? "-",
          "Joining Prorated": custom_attendance?.joining_prorated ?? "-",
          "Leave Days": custom_attendance?.leave_days ?? "-",
          "Late Days": custom_attendance?.late_days ?? "-",
          "Absent Days": custom_attendance?.absent_days ?? "-",
        };
      }
    );

    // Create worksheet and apply header styles
    const ws = XLSX.utils.json_to_sheet(processedData);
    const headerKeys = Object.keys(processedData[0] || {});

    // Apply styles for header row
    headerKeys.forEach((key, index) => {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: index });
      if (ws[cellAddress]) {
        ws[cellAddress].s = {
          font: { bold: true },
          alignment: { vertical: "center" },
          fill: {
            fgColor: { rgb: "F3F3F3" },
          },
        };
      }
    });

    // Freeze the header row (Row 1)
    ws["!freeze"] = { xSplit: 0, ySplit: 1 };

    // Ensure Excel recognizes the header row by setting the correct range
    ws["!ref"] = `A1:${XLSX.utils.encode_cell({
      r: processedData.length,
      c: headerKeys.length - 1,
    })}`;

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "SheetJS");

    XLSX.writeFile(wb, `Custom_attendance_report.xlsx`);

    setLoading(false);
  };

  return (
    <>
      <CustomModal {...rest} handleClose={handleClose} footer={null}>
        <div>
          <div className="flex justify-center items-center mt-4 mb-4">
            <img src={ExcelLogo} alt="pdf_file_icon" className="w-[80px]" />
          </div>
          <div className="flex justify-center items-center mt-4 mb-4 font-bold text-xl">
            <h4>Download Report</h4>
          </div>
          <div className="flex justify-center items-center mt-2 mb-2 font-normal text-slate-500">
            You can download maximum of past 31 days data.
          </div>
          <div className="flex justify-center items-center mt-4 mb-4">
            <RangePicker
              className="my-2 clear-button-hide"
              value={dates}
              // disabledDate={disabledDate}
              onChange={(d) => {
                if (d && d[0] && d[1]) setDates([d[0], d[1]]);
              }}
            />
          </div>{" "}
          <div className="flex flex-col items-center gap-4 mt-4 mb-4">
            <Button
              className="modal-button w-[250px]"
              type="primary"
              htmlType="submit"
              size="middle"
              loading={loading}
              onClick={() => {
                handleDownloadExcel();
              }}
            >
              Download
            </Button>
            <Button
              className="normal-dark-button modal-button  w-[250px]"
              onClick={handleClose}
              size="middle"
            >
              Close
            </Button>
          </div>
        </div>
      </CustomModal>
    </>
  );
}
